import { configureStore } from '@reduxjs/toolkit'
import { enableMapSet } from 'immer'
import authSlice from './authSlice'
import workspaceSlice from './workspaceSlice'
import workspaceManagementSlice from './workspaceManagementSlice'
import businessSlice from './businessSlice'
import memberSlice from './memberSlice'
import performanceGroupSlice from './performanceGroupSlice'
import taskSummarySlice from './taskSummarySlice'
import taskSlice from './taskSlice'

// Enable Map and Set support in Immer for Redux Toolkit
enableMapSet()

export const store = configureStore({
  reducer: {
    auth: authSlice,
    workspace: workspaceSlice,
    workspaceManagement: workspaceManagementSlice,
    business: businessSlice,
    member: memberSlice,
    performanceGroup: performanceGroupSlice,
    taskSummary: taskSummarySlice,
    task: taskSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [],
        // Ignore Set instances in state for the loadedPages field in slices with pagination
        ignoredPaths: [
          'member.loadedPages',
          'task.loadedPages'
        ],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

// Typed hooks
export { useAppDispatch, useAppSelector } from './hooks'